<template>
  <v-dialog :value="value" persistent width="900" @click:outside="close()">
    <v-card>
      <v-card-title class="pl-6 pr-2 pt-4 pb-0">
        <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
        <div class="title h6">
          Missing Linked Items Warning
        </div>
      </v-card-title>
      <v-container fluid class="pa-0">
        <div class="mx-6 my-4">
          At least one linked item is missing. Please review before proceeding.
        </div>
        <div class="mx-6 my-4">
          {{ 'Incomplete Linked Group(s): ' + missingLinkedGroupIds.join(", ") }}
        </div>
        <v-data-table
          :loading="loading"
          :items="missingLinkedItems"
          :headers="headers"
          class="mx-4"
          no-data-text="No missing linked items"
          dense
          fixed-header
          disable-pagination
          hide-default-footer
          :items-per-page="-1"
          :height="tableHeight">
          <template #[`item.sale_price`]="{ item }">
            <span v-if="item.sale_price">${{$config.formatCurrency(item.sale_price)}}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.pack_size`]="{ item }">
            <span v-if="item.pack_size">{{item.pack_size}}</span>
            <span v-else>-</span>
          </template>
        </v-data-table>
        <div class="mt-4 d-flex justify-center">
          <v-btn class="mb-4 mr-4" text @click="close()">
            Cancel
          </v-btn>
          <v-btn class="mb-4" color="warning" @click="confirm()">
            Confirm
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'MissingLinkedItemsAlertModal',
  props: {
    value: Boolean,
    missingItems: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      headerProps: {
        class: 'accent white--text',
        sortable: false
      },
      baseHeaders: [
        { text: 'Linked Group', value: 'linked_group' },
        { text: 'Item ID', value: 'item_id' },
        { text: 'Source', value: 'source_name' },
        { text: 'Description', value: 'description' },
        { text: 'Retail Price', value: 'sale_price' },
        { text: 'Size', value: 'pack_size' }
      ]
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('submitWithMissingLinkedItemsAlert')
    }
  },
  computed: {
    headers () {
      return this.baseHeaders.map(header => {
        return { ...this.headerProps, ...header }
      })
    },
    tableHeight() {
      return this.missingItems.length <= 3 ? '135px' : this.missingItems.length <= 7 ? '315px' : '450px'
    },
    missingLinkedItems() {
      return this.missingItems.map(item => {
        return {
          ...item,
          source_name: this.$store.getters.getSourceName(item.source)
        }
      })
    },
    missingLinkedGroupIds() {
      return [...new Set(this.missingItems.map(item => item.linked_group))]
    }
  }
}
</script>
<style>
.title {
  width: 67%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>